import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { MaskedTextInput } from "react-native-mask-text";

const MaskedInputDefault = ({ mask, editable = true, value, keyboardType, onValueChange, placeholder }) => {
    return (
        <View style={styles.containerSocialContract}>
            <Text style={styles.description}>{placeholder}</Text>
            <MaskedTextInput
                editable={editable}
                mask={mask}
                value={value}
                keyboardType={keyboardType}
                onChangeText={(text) => {
                    onValueChange(text);
                }}
                style={[styles.input, !editable ? { backgroundColor: "#eee", color: "#666" } : null]}
                placeholder={placeholder}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    input: {
        outlineStyle: 'none',
        backgroundColor: '#fff',
        padding: 10,
        borderWidth: 1,
        marginTop: 10,
        borderRadius: 5
    },
    containerSocialContract: {
        marginTop: 20,
        width: 300,
    },
    description: {
        textAlign: 'justify',
        fontSize: 14,
        fontWeight: '400',
        lineHeight: 15
    },
});

export default MaskedInputDefault;